//import { useParams } from "react-router-dom";
import Construction from "../components/Construction";

function Personals() {
  //const { slug } = useParams();
  return (
    <>
    <Construction />
    </> 
  );
}

export default Personals;
